import { render, staticRenderFns } from "./CreateGenericControl.vue?vue&type=template&id=d77f3a74&"
import script from "./CreateGenericControl.vue?vue&type=script&lang=js&"
export * from "./CreateGenericControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports